var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6709 10.0292L7.67091 6.02923C7.41132 5.93511 7.12454 6.06922 7.03041 6.32881C6.98865 6.44398 6.99062 6.57045 7.03595 6.68421L9.03595 11.6842C9.087 11.8117 9.18825 11.9126 9.31593 11.9632L12.5379 13.2392L3.37695 18.3291L5.85292 15.8531C5.947 15.7594 5.99987 15.632 5.99992 15.4991V2.49924C5.99987 2.29496 5.87556 2.11125 5.68591 2.03522L0.685965 0.0352186C0.531841 -0.025578 0.357701 -0.00687495 0.219983 0.0852339C0.0824996 0.178187 4.68747e-05 0.333295 0 0.499232V20.4991C0 20.5132 0.0110156 20.5252 0.012 20.5391C0.0164531 20.6163 0.0390467 20.6913 0.0779996 20.7581C0.0979683 20.7833 0.120421 20.8064 0.144984 20.8271C0.173249 20.8652 0.206905 20.8989 0.244967 20.9271L5.24496 23.9271C5.40466 24.0243 5.60524 24.0243 5.76494 23.9271L18.7649 15.9271C18.9123 15.835 19.0012 15.6729 18.9998 15.4991V10.4992C18.9999 10.2889 18.8684 10.1011 18.6709 10.0292Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBingIcon);
export default __webpack_public_path__ + "static/media/bing-icon.6e0f2ce13b145c19a15c091f7704603a.svg";
export { ForwardRef as ReactComponent };